import React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ACTIONS from '../redux/actions/Page.js';
import * as UI_ACTIONS from '../redux/actions/UI.js';
import classNames from 'classnames';

import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { Feature, Project, Page } from '../components/index.js';
import PreloadLink from '../components/PreloadLink.js';
import Archive from '../components/ArchiveNew.jsx';
import PortfolioText from '../components/PortfolioText.jsx';

function mapStateToProps(state) {
  return {
    showcase: state.Page.showcase,
    loading: state.Page.loading,
    loaded: state.Page.loaded,
    projectHeight: state.UI.projectHeight,
    projectScrolled: state.UI.projectScrolled,
    homepageIntro: state.UI.homepageIntro,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchHome: bindActionCreators(ACTIONS.getHome, dispatch),
    fetchPage: bindActionCreators(ACTIONS.getPage, dispatch),
    setTemplate: bindActionCreators(UI_ACTIONS.setTemplate, dispatch),
    projectUnscrolled: bindActionCreators(
      UI_ACTIONS.projectUnscrolled,
      dispatch,
    ),
    updateIntro: bindActionCreators(UI_ACTIONS.updateIntro, dispatch),
    siteReady: bindActionCreators(UI_ACTIONS.siteReady, dispatch),
  };
}

class Showcase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transitioning: false,
      projectOpacity: 0.8,
      archiveOpacity: 0,
      archiveActive: false,
      projectSpacing: '100vh',
      outroActive: false,
      archiveLocked: true,
      isScrolled: false,
    };
    this.articleIndex = null;
    this.articleReady = false;
  }

  componentDidMount() {
    //console.log('Showcase mount');
    //this.props.setTemplate('home')
    this.props.fetchHome(this.props.location.pathname); // always get the showcase for now
    //this.props.fetchPage(this.props.location.pathname);
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);

    // console.log(this.props.showcase);

    if (this.props.homepageIntro === null && this.props.showcase.intros) {
      this.props.updateIntro(this.props.showcase.intros);
    }
  }

  componentDidUpdate(prevProps) {
    console.log(this.props.showcase);
    if (this.props.homepageIntro === null && this.props.showcase.intros) {
      this.props.updateIntro(this.props.showcase.intros);
    }
    this.props.siteReady();
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    const outro = document.querySelector('.PortfolioOutro');

    if (outro) {
      const height = outro.offsetHeight + 'px';
      if (height !== this.state.projectSpacing) {
        this.setState({
          projectSpacing: height,
        });
      }
    }
  };

  handleScroll = () => {
    const { body } = this.refs;
    const bounds = body.getBoundingClientRect();

    let archiveBigger = false;

    const projectsArchiveRef = document.querySelector('.ProjectsArchive');
    if (projectsArchiveRef) {
      const archiveBounds = projectsArchiveRef.getBoundingClientRect();
      archiveBigger = archiveBounds.height > window.innerHeight;
    }

    // console.log('body top', bounds.top);

    if (bounds.top < 0) {
      if (!this.state.isScrolled) {
        this.setState({ isScrolled: true });
      }
    } else {
      if (this.state.isScrolled) {
        this.setState({ isScrolled: false });
      }
    }

    if (this.props.projectScrolled) {
      let top = bounds.top - window.innerHeight;

      //console.log(top)

      if (top > 0) {
        this.props.projectUnscrolled();
      }
    }

    let outroActive = false;
    if (bounds.top + bounds.height < 0) {
      outroActive = true;
    }

    if (this.state.outroActive !== outroActive) {
      this.setState({
        outroActive: outroActive,
      });
    }
    const windowBottom = window.innerHeight / 2;
    const bottom = bounds.top + bounds.height - windowBottom;
    let opacity = 0;
    let active = false;

    if (bottom < 0) {
      const diff = Math.abs(bottom) / windowBottom;
      //console.log(diff);
      // body.style.opacity = diff;

      opacity = diff;
      active = true;

      if (opacity >= 1 && archiveBigger) {
        this.setState({
          archiveLocked: false,
        });
      } else {
        this.setState({
          archiveLocked: true,
        });
      }
    } else {
      opacity = 0;
      active = false;
    }

    if (
      active !== this.state.archiveActive ||
      opacity !== this.state.archiveOpacity
    ) {
      this.setState({
        archiveOpacity: opacity,
        archiveActive: active,
      });
    }
  };

  randomIntro = () => {
    //let rand =
    return this.props.showcase.intros[
      Math.floor(Math.random() * this.props.showcase.intros.length)
    ];
  };

  setScroll = () => {};

  setArticle = (evt, ix) => {
    this.articleIndex = ix;
  };

  render() {
    let { showcase, article, location } = this.props;
    if (!showcase) return null;

    console.log('Showcase render', this.props.location.pathname, article);

    if (
      this.props.location.pathname === '/' ||
      this.props.location.pathname === '/projects'
    ) {
      this.articleIndex = null;
    }

    let project = null;
    let gridItems = null;

    if (this.state.transitioning) {
      project = (
        <div className="Project-wrap">
          <Project loading />
        </div>
      );
    }

    if (article && this.articleReady) {
      project =
        article.type === 'pages' ? (
          <div className="Project-wrap" ref="project">
            <Page entry={article} opacity={this.state.projectOpacity} />
          </div>
        ) : (
          <div className="Project-wrap" ref="project">
            <Project entry={article} opacity={this.state.projectOpacity} />
          </div>
        );
    }

    if (showcase.content) {
      gridItems = showcase.content.map((item, ix) => {
        let showArticle = project && this.articleIndex === ix + 1;

        let className = classNames(
          'Template-gridItem',
          'Template-gridItem--' + item.style,
          { 'Template-gridItem--center': item.centered },
        );

        if ('/' + item.projectUri === location.pathname)
          this.articleIndex = ix + 1;

        let gridItem = null;

        if (item.projectUri) {
          gridItem = (
            <div key={ix + 1} className={className} ref={'item-' + (ix + 1)}>
              <PreloadLink to={item.projectUri}>
                <Feature entry={item} />
              </PreloadLink>
              <div className="Template-gridItem-loader" />
            </div>
          );
        } else {
          gridItem = (
            <div key={ix + 1} className={className} ref={'item-' + (ix + 1)}>
              <Feature entry={item} />
              <div className="Template-gridItem-loader" />
            </div>
          );
        }

        if (!showArticle) return gridItem;

        return [gridItem, project];
      });
    }

    let els = [gridItems];
    //console.log('Project?',this.articleIndex)
    if (project && this.articleIndex === 0) {
      els.unshift(project);
    }

    let bottom = null;

    if (showcase.type === 'showcase') {
      bottom = (
        <Archive
          opacity={this.state.archiveOpacity}
          active={this.state.archiveActive}
          locked={this.state.archiveLocked}
        />
      );
    } else if (showcase.type === 'portfolios') {
      bottom = (
        <React.Fragment>
          <PortfolioText
            opacity={1}
            clickable={this.state.archiveActive}
            active={this.state.outroActive}
            text={showcase.bottomText}
            hideSignup={showcase.hideSignup}
            stories={showcase.stories}
            storyTitle={showcase.storiesTitle || 'Stories'}
            bgColour={showcase.bottomBG}
            listId={showcase.listId}
            archive={showcase.archive}
          />
          {/* <ProjectsArchive projects={showcase.archive} /> */}
        </React.Fragment>
      );
    }

    const bodyStyle = {
      marginBottom: this.state.archiveLocked ? this.state.projectSpacing : '0',
    };

    const templateClass = classNames(
      'Template',
      'Template--home',
      {
        'template-is-scrolled': this.state.isScrolled,
      },
      `Template--${showcase.template}`,
    );

    return (
      <div className={templateClass}>
        {showcase.pageTitle && (
          <Helmet>
            <title>{showcase.pageTitle}</title>
            <meta name="description" content={showcase.metaDesc} />
          </Helmet>
        )}
        <div
          className="Template-spacer"
          ref="spacer"
          style={{ height: this.props.projectHeight + 'px' }}
        />

        <div className="Template-head"> {showcase.title}</div>
        <div className="Template-body" ref="body" style={bodyStyle}>
          {showcase.template !== 'home' && (
            <div className="Template-intro">
              <h1>{this.props.homepageIntro}</h1>
            </div>
          )}

          <div className="Template-grid">{els}</div>
        </div>
        {bottom}
      </div>
    );
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Showcase),
);



// WEBPACK FOOTER //
// ./src/js/templates/showcase.jsx